const { Urls } = require(
  BUILD_ENV === "prod" 
    ? "./prodConstants" 
    : BUILD_ENV === "demo" 
      ? "./demoConstants" 
      : "./drConstants"
);

export {
  Urls
};
